import { useState, useCallback } from "react";
import { Pipeline } from "..";
import { MailingTableRow } from "../../index";
import api from "api/api";
import { Toast } from "components/toast";

async function getPipelineData(mailingId: number): Promise<Pipeline[]> {
  try {
    const { data } = await api.get<Pipeline[]>(
      `/pipeline/status/mailing/${mailingId}`
    );
    return data;
  } catch (e: any) {
    Toast({
      title: "Erro ao obter dados mailing",
      status: "error",
    });
    throw e;
  }
}

export function usePipelineData(row: MailingTableRow, isOpen: boolean) {
  const [pipelineData, setPipelineData] = useState<Pipeline[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeStep, setActiveStep] = useState(0);

  const refetch = async () => {
    setIsLoading(true);
    try {
      const data = await getPipelineData(row.id);
      setPipelineData(data);

      const isFinished =
        data.filter((i: Pipeline) => i.pipelineStatus === "FINALIZADO")
          .length === data.length;
      setActiveStep(
        isFinished ? row.currentPipelineOrdem! : row.currentPipelineOrdem! - 1
      );
    } catch (e) {
      // Error handled in service
    } finally {
      setIsLoading(false);
    }
  };

  return {
    pipelineData,
    isLoading,
    setIsLoading,
    activeStep,
    setActiveStep,
    refetch,
  };
}
